import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { Medication } from '../../models/medication';

@Injectable({
  providedIn: 'root',
})
export class PatientMedicationsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientMedicationsEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientMedications`;

  getPatientMedications(patientId: number): Observable<Medication[]> {
    const url = `${this.patientMedicationsEndpoint}?patientId=${patientId}`;
    // Opted out of the global error page: MedicationsComponent renders app-error-state with a retry,
    // so a failed read no longer tears the patient off the page.
    return this.utilityService.getRequest<Medication[]>(url, { skipGlobalError: true });
  }

  getPatientMedicationById(medicationId: number, patientId: number): Observable<Medication> {
    const url = `${this.patientMedicationsEndpoint}/${medicationId}?patientId=${patientId}`;
    return this.utilityService.getRequest<Medication>(url);
  }
}
